var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckoutCustomizeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.6201V12.6801C20 13.2401 19.54 13.7001 18.97 13.7001H17.04C15.96 13.7001 14.97 12.9101 14.88 11.8301C14.82 11.2001 15.06 10.6101 15.48 10.2001C15.85 9.8201 16.36 9.6001 16.92 9.6001H18.97C19.54 9.6001 20 10.0601 20 10.6201Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.38 11.9599C13.29 10.9099 13.67 9.8799 14.43 9.1299C15.07 8.4799 15.96 8.0999 16.92 8.0999H17.49C17.77 8.0999 18 7.8699 17.96 7.5899C17.69 5.6499 16.01 4.1499 14 4.1499H4C1.79 4.1499 0 5.9399 0 8.1499V15.1499C0 17.3599 1.79 19.1499 4 19.1499H14C16.02 19.1499 17.69 17.6499 17.96 15.7099C18 15.4299 17.77 15.1999 17.49 15.1999H17.04C15.14 15.1999 13.54 13.7799 13.38 11.9599ZM11 9.8999H5C4.59 9.8999 4.25 9.5699 4.25 9.1499C4.25 8.7299 4.59 8.3999 5 8.3999H11C11.41 8.3999 11.75 8.7399 11.75 9.1499C11.75 9.5599 11.41 9.8999 11 9.8999Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2099 1.9801C12.4699 2.2501 12.2399 2.6501 11.8599 2.6501H4.02991C2.93991 2.6501 1.91991 2.9701 1.06991 3.5201C0.679907 3.7701 0.149907 3.5001 0.339907 3.0701C0.899907 1.7601 2.20991 0.850098 3.71991 0.850098H9.33991C10.4999 0.850098 11.5299 1.2601 12.2099 1.9801Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutCustomizeicon);
export default __webpack_public_path__ + "static/media/checkout-customize.icon.dfc97e1a3599be1816c597b938e4de9d.svg";
export { ForwardRef as ReactComponent };